import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({
    providedIn: 'root',
})
export class RoleAuthGuard implements CanActivate {
    private authenticationService = inject(AuthenticationService);
    private router = inject(Router);

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {

        const allowedRoles = route.data.allowedRoles;

        if (this.authenticationService.isAuthenticated && this.authenticationService.checkRole(allowedRoles)) {
            return true;
        }

        return this.router.createUrlTree([
            '/',
        ]);
    }
}
